import Button from '@atlaskit/button';
import DynamicTable from '@atlaskit/dynamic-table';
import React from 'react';

const header = () => {
  return {
    cells: [{
      key: 'title',
      content: 'Title',
      width: 37
    }, {
      key: 'date',
      content: 'Date',
      width: 25
    }, {
      key: 'repeatAnnually',
      content: 'Repeat',
      width: 19
    }, {
      key: 'delete',
      width: 19
    }]
  };
};

const HolidayTable = props => {
  const generateHolidayRows = holidays => {
    return holidays.map((h, i) => createRow(h, i));
  };

  const createRow = (holidayItem, index) => {
    return {
      cells: [{
        key: holidayItem.title,
        content: holidayItem.title
      }, {
        key: holidayItem.date,
        content: holidayItem.date
      }, {
        key: holidayItem.repeatAnnually,
        content: holidayItem.repeatAnnually ? 'Annually' : 'Never'
      }, {
        key: 'delete-button',
        content: /*#__PURE__*/React.createElement(Button, {
          onClick: () => {
            props.onDelete(index);
          }
        }, "Delete")
      }]
    };
  };

  return props.holidays.length > 0 && /*#__PURE__*/React.createElement(DynamicTable, {
    head: header(),
    rows: generateHolidayRows(props.holidays)
  });
};

export default HolidayTable;